import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

function NotFound(props) {

    var { t } = useTranslation();

    /**
     * React.js built-in default navigation mechanism
     */
    var navigate = useNavigate();

    /**
     * Go to previous page in web browser
     */
    function handleBackButtonClick() {
        navigate(-1);
    }

    /**
     * Redirect to main Home page
     */
    function handleRedirectToHome() {
        navigate('/');
    }

    return (
        <div className="uk-container uk-margin-large-top">
            <h1>
                {t("ui.error.404")}
            </h1>

            <p>

            </p>

            <div className="uk-margin-large-top">
                <button className="uk-button uk-button-primary uk-button-jai" onClick={handleBackButtonClick}>
                    {t("ui.button.back")}
                </button>
                <button className="uk-button uk-button-primary uk-button-jai uk-margin-left" onClick={handleRedirectToHome}>
                    {t("ui.pages.home")}
                </button>
            </div>
        </div>
    );
}

export default NotFound;